<template>
  <div class="login-page">
    <!-- Left panel -->
    <div class="login-left">
      <AuthLeftPanel />
    </div>

    <!-- Right panel -->
    <div class="login-right">
      <!-- Info card -->
      <div class="register-info-card">
        <p class="register-info-card-title text-title">
          {{ $t("register.info_title") }}
        </p>
        <p class="register-info-card__text text-body">
          {{ $t("register.info_text") }}
        </p>
      </div>

      <div class="login-box">
        <b-form v-if="step === 1" @submit.prevent="submitEmail">
          <h5 class="form-title text-heading">{{ $t("register.title") }}</h5>
          <span class="register-description text-body-sm">{{
            $t("register.description")
          }}</span>
          
        <!-- Хэрэглэгчийн төрөл сонгох түр коммент болгов -->
          <!-- <UISelecter
            v-model="selectedType"
            :options="userType"
            label="Хэрэглэгчийн төрөл сонгох"
            :error="!!errorMsg && !selectedType"
          /> -->
          <label class="text-label">{{ $t("register.email") }}</label>
          <UITextField
            v-model="email"
            type="email"
            :label="$t('register.email_placeholder')"
          />
          <b-alert :show="!!errorMsg" variant="danger" class="mt-2">{{
            errorMsg
          }}</b-alert>
          <UIButton
            type="submit"
            :label="$t('register.submit')"
            variant="primary"
            :block="true"
            :loading="loading"
            class="mt-3"
          />
        </b-form>

        <!-- Step 2: OTP -->
        <template v-if="step === 2">
          <p class="otp-hint">{{ $t("register.otp_hint", { email }) }}</p>
          <b-form @submit.prevent="submitOtp">
            <label class="text-label">{{ $t("register.otp") }}</label>
            <UITextField
              v-model="otp"
              type="text"
              :label="$t('register.otp_placeholder')"
            />
            <b-alert :show="!!errorMsg" variant="danger" class="mt-2">{{
              errorMsg
            }}</b-alert>
            <UIButton
              type="submit"
              :label="$t('register.otp_submit')"
              variant="primary"
              :block="true"
              :loading="loading"
              class="mt-3"
            />
          </b-form>
          <button class="resend-btn" :disabled="loading" @click="submitEmail">
            {{ $t("register.resend") }}
          </button>
        </template>

        <!-- Step 3: Set password -->
        <template v-if="step === 3">
          <b-form @submit.prevent="submitPassword">
            <label class="text-label">{{ $t("register.password") }}</label>
            <UITextField
              v-model="password"
              type="password"
              :label="$t('register.password_placeholder')"
            />
            <label class="text-label">{{
              $t("register.password_confirm")
            }}</label>
            <UITextField
              v-model="passwordConfirm"
              type="password"
              :label="$t('register.password_placeholder')"
            />
            <b-alert :show="!!errorMsg" variant="danger" class="mt-2">{{
              errorMsg
            }}</b-alert>
            <UIButton
              type="submit"
              :label="$t('register.password_submit')"
              variant="primary"
              :block="true"
              :loading="loading"
              class="mt-3"
            />
          </b-form>
        </template>

        <!-- Step 4: Success -->
        <template v-if="step === 4">
          <b-alert show variant="success" class="mt-3">{{
            $t("register.success")
          }}</b-alert>
          <UIButton
            :label="$t('register.login_link')"
            variant="primary"
            :block="true"
            class="mt-3"
            @click="$router.push('/user/login')"
          />
        </template>

        <template v-if="step !== 4">
          <div class="login-divider text-body-xs">
            <span>{{ $t("login.or") || "эсвэл" }}</span>
          </div>
          <UIButton
            :label="$t('register.login_link')"
            variant="secondary"
            :block="true"
            @click="$router.push('/user/login')"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import UIButton from "../../components/UI/UIButton.vue";
import AuthLeftPanel from "../../components/UI/AuthLeftPanel.vue";
import UITextField from "../../components/UI/UITextField.vue";
import UISelecter from "../../components/UI/UISelecter.vue";

export default {
  name: "RegisterPage",
  components: { UIButton, AuthLeftPanel, UITextField, UISelecter},
  data() {
    return {
      step: 1,
      email: "",
      otp: "",
      password: "",
      passwordConfirm: "",
      registrationToken: null,
      loading: false,
      errorMsg: "",
      logoUrl: process.env.VUE_APP_LOGO_URL || "/img/atlas.svg",
      logoFailed: false,
      // selectedType: "",
      // userType : [
      //   {label: "Хувь хүн", value: "1"},
      //   {label: "Байгууллага", value: "2"},
      //   {label: "Хүүхэд", value: "3"},
      //   {label: "Гадаад иргэн", value: "4"},
      // ]
    };
  },
  methods: {
    onLogoError() {
      this.logoFailed = true;
    },
    async submitEmail() {
      this.errorMsg = "";
      this.loading = true;
      try {
        const { data } = await axios.post("/api/enduser/register/otp", {
          email: this.email.trim(),
        });
        if (data && data.registration_token) {
          this.registrationToken = data.registration_token;
          this.otp = "";
          this.step = 2;
        } else {
          this.errorMsg = "Серверээс бүртгэлийн токен ирсэнгүй.";
        }
      } catch (err) {
        this.errorMsg =
          err?.response?.data?.message || this.$t("register.error_generic");
      } finally {
        this.loading = false;
      }
    },
    async submitOtp() {
      this.errorMsg = "";
      this.loading = true;
      try {
        const { data } = await axios.post("/api/enduser/register/otp/confirm", {
          otp: this.otp.trim(),
          registration_token: this.registrationToken,
        });
        if (data && data.registration_token) {
          this.registrationToken = data.registration_token;
          this.password = "";
          this.passwordConfirm = "";
          this.step = 3;
        } else {
          this.errorMsg = "OTP баталгаажуулалтын токен олдсонгүй.";
        }
      } catch (err) {
        this.errorMsg =
          err?.response?.data?.message || this.$t("register.otp_error");
      } finally {
        this.loading = false;
      }
    },
    async submitPassword() {
      this.errorMsg = "";
      if (this.password !== this.passwordConfirm) {
        this.errorMsg = this.$t("register.password_mismatch");
        return;
      }
      if (this.password.length < 8) {
        this.errorMsg = this.$t("register.password_min");
        return;
      }
      this.loading = true;
      try {
        const { data } = await axios.post("/api/enduser/register/complete", {
          password: this.password,
          password_confirmation: this.passwordConfirm,
          registration_token: this.registrationToken,
        });
        if (data && data.kc_uuid) {
          this.step = 4;
        } else {
          this.errorMsg = data.message || "Бүртгэл амжилтгүй боллоо.";
        }
      } catch (err) {
        const code = err?.response?.data?.code;
        const msg = err?.response?.data?.message;
        if (code === "VALIDATION_FAILED") {
          this.errorMsg = this.$t("register.password_min");
        } else {
          this.errorMsg = msg || this.$t("register.error_generic");
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
}

.login-left {
  flex: 0 0 50%;
  overflow: hidden;
}
.login-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 48px 40px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10%;
  padding-top: 100px;
}

@media (max-width: 768px) {
  .login-left {
    display: none;
  }
  .login-right {
    width: 100%;
  }
}

.login-box {
  width: 100%;
  max-width: 350px;
  padding-top: 32px;
}

/* ── Info card ── */
.register-info-card {
  background: #fdf6ee;
  border: 1px solid #e8a96a;
  border-radius: 12px;
  padding: 20px 32px;
  margin-bottom: 42px;
  width: 100%;
  max-width: 816px; 
  box-sizing: border-box;
}
.register-info-card-title {
  color: #1a2035;
  margin-bottom: 10px;
  text-align: center;
}
.register-info-card__text {
  line-height: 1.7;
  color: #555e6d;
  margin: 0;
}
@media (max-width: 768px) {
  .register-info-card {
    padding: 16px 20px;
    margin-bottom: 24px; 
  } 
  .register-info-card-title {
    font-size: 1.3rem; 
  }
}

/* ── Titles ── */
.form-title {
  color: #1a2035;
  margin-bottom: 6px;
}
.register-description {
  display: block;
  color: #888e9b !important;
  margin-bottom: 20px;
  line-height: 1.5;
}

label {
  color: #555e6d;
  font-size: 13px;
  margin-bottom: 4px;
  display: block;
}

.otp-hint {
  color: #555e6d;
  font-size: 13px;
  margin-bottom: 16px;
  text-align: center;
}

.resend-btn {
  display: block;
  width: 100%;
  margin-top: 8px;
  background: none;
  border: none;
  color: #aab0bc;
  font-size: 12px;
  cursor: pointer;
  text-align: center;
  padding: 6px 0;
}
.resend-btn:hover {
  color: #2d3f9c;
}

/* ── Divider ── */
.login-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0;
  color: #aab0bc !important;
}
.login-divider::before,
.login-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e4e7ef;
}
</style>
